import React from 'react';
import { safariEnquiriesColumns, Table } from '../../../commons/Table';
import { useInquiries } from '../../../../hooks';
import { Card } from '../../../ui/Card';

const Inquiries = () => {
  const { inquiries, loading } = useInquiries();

  return (
    <div className='space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700'>
      {/* Page Header */}
      <div className='flex flex-col md:flex-row md:items-center justify-between gap-4'>
        <div>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Safari Inquiries
          </h1>
          <p className='text-gray-500 dark:text-gray-400 mt-1 text-sm md:text-base'>
            View and respond to general questions from potential clients.
          </p>
        </div>
      </div>
      
      {/* Main Content Card */}
      <Card variant='glass' className='overflow-hidden border-none shadow-xl shadow-gray-200/50 dark:shadow-none'>
        {/* @ts-ignore */}
        <Table 
          columns={safariEnquiriesColumns} 
          data={inquiries} 
          loading={loading} 
          hideActions 
          placeholder='Search inquiries by keyword or email...'
          recordName='Inquiries'
        />
      </Card>
    </div>
  );
};

export default Inquiries;
